import Cookies from "js-cookie";

export interface PaginationParams {
    page: number;
    pageSize: number;
}

export interface SortParams {
    sortField: string | undefined;
    sortOrder: 'asc' | 'desc' | undefined;
}

export interface SearchParams extends PaginationParams, SortParams
{
    filter: string | undefined;
}
export default class ApiService {
    
    getRequestOptions(opts: {} = {}) {
        const options : any = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            ...opts
        };
        
        return options;
    }

    // @ts-ignore
    private async _fetch(endpoint: string, opts: any) {
        const response = await fetch(endpoint, opts);
        
        if (response.status === 401) {
            console.error(response);
            const wwwAuth = response.headers.get('WWW-Authenticate') || '';
            if (wwwAuth.startsWith('Bearer error="invalid_token"')) {
                Cookies.remove('mat');
                window.location.reload();
                return Promise.reject('Unauthorized');
            }
        }
        
        return response;
    }
    // @ts-ignore
    protected async get(endpoint: string) {
        const opts = this.getRequestOptions({
            method: 'GET'
        });

        return this._fetch(endpoint, opts);
    }

    // @ts-ignore
    protected async post(endpoint: string, value: any | undefined = undefined) {
        const opts = this.getRequestOptions({
            method: 'POST',
        });
        if (value !== undefined) {
            opts.body = JSON.stringify(value)
        }

        return this._fetch(endpoint, opts);
    }

    protected async put(endpoint: string, value: any) {
        const opts = this.getRequestOptions({
            method: 'PUT',
            body: JSON.stringify(value)
        });

        return this._fetch(endpoint, opts);
    }

    protected async patch(endpoint: string, value: any) {
        const opts = this.getRequestOptions({
            method: 'PATCH',
            body: JSON.stringify(value)
        });

        return this._fetch(endpoint, opts);
    }

    protected async delete(endpoint: string) {
        const opts = this.getRequestOptions({
            method: 'DELETE'
        });

        return this._fetch(endpoint, opts);
    }

    protected async postFormData(endpoint: string, value: FormData) {
        const opts = this.getRequestOptions({
            method: 'POST',
            body: value
        });

        // @ts-ignore
        delete opts.headers["Content-Type"];

        return this._fetch(endpoint, opts);
    }

    protected async putFormData(endpoint: string, value: FormData) {
        const opts = this.getRequestOptions({
            method: 'PUT',
            body: value
        });

        // @ts-ignore
        delete opts.headers["Content-Type"];

        return this._fetch(endpoint, opts);
    }
}